import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "text-end" }

import SelectField from "../Misc/SelectField.vue";
import {BButton} from "../BButton";
import {useCommunityPolicingStore} from "@/stores/communityPolicingStore";
import {storeToRefs} from "pinia";
import {ref, watch, computed} from "vue";
import {SelectItem} from "@/types";
import {handleError} from "@/stores/storeHelper";

export default /*@__PURE__*/_defineComponent({
  __name: 'ZeroReport',
  setup(__props) {

const communityPolicingStore = useCommunityPolicingStore();
const {getOrisForSelectList: agencies} = storeToRefs(communityPolicingStore);
const selectedOri = ref("");
const year = ref(0);
const years = ref([] as SelectItem[]);
const month = ref(0);
const months = ref([] as SelectItem[]);
const loading = ref<boolean>(false);
const canSubmit = computed(() => {
    return year.value && month.value && selectedOri.value != null;
});

watch(
    () => selectedOri.value,
    async (val: any) => {
        if (selectedOri.value) {
            communityPolicingStore.setSelectedOri(selectedOri.value);
            await communityPolicingStore.fetchDatasetDetailsForOri();
            generateYearArray();
        }
    }
);

watch(
    () => year.value,
    async (val: any) => {
        generateMonthArray();
    }
);

const submit = async () => {
    loading.value = true;
    try {
        await communityPolicingStore.submitZeroReport(selectedOri.value, year.value, month.value);
        window.location.href = "dataupload.aspx?source=6";
    } catch (error) {
        handleError(error);
    } finally {
        loading.value = false;
    }
};

function generateMonthArray() {
    if (year.value === 0) {
        return [];
    }

    var data = communityPolicingStore.getDetailsForCurrentDataset;
    months.value = getMonthsAsSelectItemArray();

    let endDate = data.agency_end_date != undefined ? new Date(data.agency_end_date) : new Date(Date.now());
    let startDate = data.agency_start_date != undefined ? new Date(data.agency_start_date) : new Date(data.start_date);
    let filtered = months.value;

    if (startDate.getFullYear() == endDate.getFullYear()) {
        filtered = months.value.filter((item) => {
            if (item.value > startDate.getMonth() && item.value <= endDate.getMonth()) return item;
        });
    } else {
        if (year.value == endDate.getFullYear()) {
            filtered = months.value.filter((item) => {
                if (item.value <= endDate.getMonth()) return item;
            });
        } else if (year.value == startDate.getFullYear()) {
            filtered = months.value.filter((item) => {
                if (item.value > startDate.getMonth()) return item;
            });
        } else {
            filtered = months.value;
        }
    }

    months.value = filtered.sort((n1, n2) => {
        if (n1.value < n2.value) {
            return 1;
        }
        if (n1.value > n2.value) {
            return -1;
        }
        return 0;
    });
}

function handleYearUpdate(newYear) {
    generateMonthArray();
}

function getMonthsAsSelectItemArray() {
    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ] as const;

    let monthsArray = [] as SelectItem[];

    monthNames.map((value, index) => {
        monthsArray.push({label: value, value: index + 1} as SelectItem);
    });

    return monthsArray;
}
function generateYearArray() {
    var data = communityPolicingStore.getDetailsForCurrentDataset;

    years.value = [] as SelectItem[];

    if (data != undefined) {
        let endDate = data.agency_end_date != undefined ? new Date(data.agency_end_date) : new Date(Date.now());

        //Since we can't submit a zero report for the current month were going to hide the current year is we're still in january otherwise the month drop down is blank.
        if (endDate.getFullYear() === new Date(Date.now()).getFullYear() && endDate.getMonth() === 0) {
            endDate.setFullYear(endDate.getFullYear() - 1, 11);
        }

        let startDate =
            data.agency_start_date != undefined ? new Date(data.agency_start_date) : new Date(data.start_date);

        for (let i = endDate.getFullYear(); i >= startDate.getFullYear(); i--) {
            years.value.push({label: `${i}`, value: i} as SelectItem);
        }

        if (years.value.length > 0) {
            year.value = years.value[0].value;
            handleYearUpdate(year.value);
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submit, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("label", {
        for: "agency",
        class: "form-label"
      }, "Agency:", -1)),
      _createVNode(SelectField, {
        id: "agency",
        modelValue: selectedOri.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOri).value = $event)),
        "select-items": _unref(agencies),
        "is-horizontal": false,
        "is-required": true
      }, null, 8, ["modelValue", "select-items"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("label", {
        for: "year",
        class: "form-label"
      }, "Year:", -1)),
      _createVNode(SelectField, {
        id: "year",
        modelValue: year.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((year).value = $event)),
        "select-items": years.value,
        "is-horizontal": false,
        "is-required": true
      }, null, 8, ["modelValue", "select-items"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[5] || (_cache[5] = _createElementVNode("label", {
        for: "month",
        class: "form-label"
      }, "Month:", -1)),
      _createVNode(SelectField, {
        id: "month",
        modelValue: month.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((month).value = $event)),
        "select-items": months.value,
        "is-horizontal": false,
        "is-required": true
      }, null, 8, ["modelValue", "select-items"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(BButton), {
        type: "submit",
        loading: loading.value,
        disabled: !canSubmit.value
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode(" Submit ")
        ])),
        _: 1,
        __: [6]
      }, 8, ["loading", "disabled"])
    ])
  ], 32))
}
}

})